import { useEventStore } from "@/event";
import {
	tilerepoRemovableEventBuildingTypes,
	type FrameName,
} from "@/game/entities/config";

export function isTemporaryEventBuildingActive(frameName: FrameName): boolean {
	const eventType = tilerepoRemovableEventBuildingTypes.get(frameName);
	return (
		useEventStore().isActive &&
		eventType !== undefined &&
		useEventStore().attributes.type === eventType
	);
}

// Demolition must not return buildings to inventory outside the matching event
export function skipDemolishToStorage(prevFrameName: FrameName): boolean {
	return (
		tilerepoRemovableEventBuildingTypes.has(prevFrameName) &&
		!isTemporaryEventBuildingActive(prevFrameName)
	);
}
